import script from "./removeTokenAsset.vue?vue&type=script&setup=true&lang=js"
export * from "./removeTokenAsset.vue?vue&type=script&setup=true&lang=js"

import "./removeTokenAsset.vue?vue&type=style&index=0&id=87e0f174&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-87e0f174"]])

export default __exports__